import { render, staticRenderFns } from "./CategoryAttribute.vue?vue&type=template&id=526c9608&scoped=true"
import script from "./CategoryAttribute.vue?vue&type=script&lang=js"
export * from "./CategoryAttribute.vue?vue&type=script&lang=js"
import style0 from "./CategoryAttribute.vue?vue&type=style&index=0&id=526c9608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c9608",
  null
  
)

export default component.exports